import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Tools from './pages/Tools';
import Videos from './pages/Videos';
import Stream from './pages/Stream';
import Reviews from './pages/Reviews';
import Streamers from './pages/Streamers';
import Contact from './pages/Contact';
import TrophyTracker from './pages/TrophyTracker';
import FollowTheMouse from './pages/FollowTheMouse';
import ScrollToTop from './components/ScrollToTop';
import "./styles.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Tools />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/stream" element={<Stream />} />
        <Route path="/games" element={<Reviews />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/streamers" element={<Streamers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tools/trophy-tracker" element={<TrophyTracker />} />
        <Route path="/tools/follow-the-mouse" element={<FollowTheMouse />} />
      </Routes>
    </Router>
  );
}

export default App;
